export * from 'subcompanies/selectors/subcompanies_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/selectors/index.js